import Transport from '../Transport';

const transport = new Transport();

export const getDepartments = async () => {
    try {
        const result = await transport.get({ path: `departments` });
        return result.data.statusCode === 200 ? result.data.data.departments : [];
    } catch (error) {
        return null;
    }
};

export const createDepartment = async (meetingId, departmentData) => {
    try {
        const result = await transport.post({ path: `departments`, data: departmentData });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const updateDepartment = async departmentData => {
    try {
        const result = await transport.put({
            path: `departments/${departmentData._id}`,
            data: departmentData,
        });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const deleteDepartment = async departmentId => {
    try {
        const result = await transport.delete({ path: `departments/${departmentId}` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};
